import React from 'react'
import { Link } from 'react-router-dom'

function HomeHero({user}) {
  return (
    <div><>
    {/* Component Code */}
    <div
      className="relative h-screen w-full flex items-center justify-center text-center bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80)"
      }}
    >
      <div className="absolute top-0 right-0 bottom-0 left-0 bg-gray-900 opacity-75" />
      <main className="px-4 sm:px-6 lg:px-8 z-10">
        <div className="text-center">
          <h2 className="text-4xl tracking-tight leading-10 font-medium sm:text-5xl text-white sm:leading-none md:text-6xl">
            <span className="text-white font-bold"><Link to='/'> Qualifinder HR; </Link></span> Beta!
          </h2>
          <p className="mt-3 text-white sm:mt-5 sm:text-md sm:max-w-xl sm:mx-auto md:mt-5">
    This is just a beta phase of Our Platform.  As we fine-tune our revolutionary platform, you have the exclusive chance to be among the first to experience our cutting-edge features
          </p>
          {!user?<>
          
            <div className="mt-5 sm:mt-8 sm:flex justify-center">
            <div className="rounded-md shadow">
             
              <Link
                to="/login"
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-regular rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:px-10"
              >
              Try Beta Now <br/>
             (Limited Features!)
              </Link>
            </div>
            <div className="mt-3 sm:mt-0 sm:ml-3">
              <a
                href="#"
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-regular rounded-md text-indigo-700 bg-indigo-100 hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out md:py-4 md:px-10"
              >
                Subscribe to  <br/>
                waitlist
              </a>
            </div>
          </div>
          </>:<><div className="mt-5 sm:mt-8 sm:flex justify-center">

            <div className="mt-3 sm:mt-0 sm:ml-3">
            <Link
                to="/go-beta"
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-regular rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:px-10"
              >
                Analyze Resume  <br/>
              
              </Link>
            </div>
          </div></>}
          
        </div>
      </main>
    </div>
    
  </>
  </div>
  )
}

export default HomeHero